module.exports = __webpack_public_path__ + "img/banner.f0d5439f.png";